export const FIREBASE_PATH_PROMOTIONS = "promotions"
export const PROMOTION_DATE_FORMAT = "DD.MM.YYYY"
export const PLANNED_PROMOTION_STATUS_COLOR = "#1890ff"
export const ACTIVE_PROMOTION_STATUS_COLOR = "#52c41a"
export const EXPIRED_PROMOTION_STATUS_COLOR = "#9a9a9a"
